var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase, ReactQuestionFactory, ReactElementFactory } from "survey-react-ui";
var SidebarComponent = /** @class */ (function (_super) {
    __extends(SidebarComponent, _super);
    function SidebarComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        return _this;
    }
    Object.defineProperty(SidebarComponent.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SidebarComponent.prototype.getStateElement = function () {
        return this.model;
    };
    SidebarComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.model.initResizeManager(this.containerRef.current);
    };
    SidebarComponent.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.model.resetResizeManager();
    };
    SidebarComponent.prototype.canRender = function () {
        if (!this.model)
            return false;
        return _super.prototype.canRender.call(this);
    };
    SidebarComponent.prototype.renderElement = function () {
        var _this = this;
        var style = { display: this.model.renderRoot ? "" : "none" };
        var containerStyle = { display: this.model.renderContainer ? "" : "none" };
        var items = this.model.pages.map(function (page) { return React.createElement(SidebarPage, { page: page, key: page.id }); });
        var headerArea = ReactElementFactory.Instance.createElement(this.model.header.component, { model: this.model.header.componentModel });
        var sideArea = null;
        if (this.model.sideAreaComponentName) {
            sideArea = ReactElementFactory.Instance.createElement(this.model.sideAreaComponentName, { model: this.model.sideAreaComponentData });
        }
        return (React.createElement("div", { className: this.model.rootCss, style: style },
            React.createElement("div", { className: "svc-side-bar__shadow", onClick: function () { return _this.model.collapseSidebar(); }, style: containerStyle }),
            React.createElement("div", { className: "svc-flex-row svc-side-bar__wrapper" },
                React.createElement("div", { className: "svc-side-bar__container-wrapper", style: containerStyle },
                    React.createElement("div", { ref: this.containerRef, className: "svc-side-bar__container" },
                        headerArea,
                        React.createElement("div", { className: "svc-side-bar__container-content" }, items))),
                sideArea)));
    };
    return SidebarComponent;
}(SurveyElementBase));
export { SidebarComponent };
var SidebarPage = /** @class */ (function (_super) {
    __extends(SidebarPage, _super);
    function SidebarPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SidebarPage.prototype, "page", {
        get: function () {
            return this.props.page;
        },
        enumerable: false,
        configurable: true
    });
    SidebarPage.prototype.getStateElement = function () {
        return this.page;
    };
    SidebarPage.prototype.renderElement = function () {
        if (!this.page.visible)
            return null;
        var component = ReactElementFactory.Instance.createElement(this.page.componentName, { model: this.page.componentData });
        return component;
    };
    return SidebarPage;
}(SurveyElementBase));
ReactQuestionFactory.Instance.registerQuestion("svc-side-bar-page", function (props) {
    return React.createElement(SidebarPage, props);
});
export default SidebarComponent;
ReactElementFactory.Instance.registerElement("svc-side-bar", function (props) {
    return React.createElement(SidebarComponent, props);
});
